import { useState, useRef, useEffect, useCallback } from "react";

var DARK = "#48494b";
var LIGHT = "#e3e5e4";
var CORRECT = "#48494b";
var WRONG = "#a83828";
var BW = 20;
var BH = 20;
var CELL = 22;

var SHAPES = [
  { name: "I", cells: [[0,0],[1,0],[2,0],[3,0]] },
  { name: "O", cells: [[0,0],[1,0],[0,1],[1,1]] },
  { name: "T", cells: [[0,0],[1,0],[2,0],[1,1]] },
  { name: "S", cells: [[1,0],[2,0],[0,1],[1,1]] },
  { name: "Z", cells: [[0,0],[1,0],[1,1],[2,1]] },
  { name: "L", cells: [[0,0],[0,1],[0,2],[1,2]] },
  { name: "J", cells: [[1,0],[1,1],[1,2],[0,2]] },
  { name: "dot", cells: [[0,0]] },
  { name: "duo", cells: [[0,0],[1,0]] },
  { name: "tri", cells: [[0,0],[1,0],[2,0]] },
  { name: "corner", cells: [[0,0],[1,0],[0,1]] },
];

function normRotate(cells) {
  var r = cells.map(function(c) { return [c[1], -c[0]]; });
  var mx = Math.min.apply(null, r.map(function(c) { return c[0]; }));
  var my = Math.min.apply(null, r.map(function(c) { return c[1]; }));
  return r.map(function(c) { return [c[0] - mx, c[1] - my]; });
}

function emptyBoard() { return Array.from({ length: BH }, function() { return Array(BW).fill(0); }); }
function emptyColors() { return Array.from({ length: BH }, function() { return Array(BW).fill(null); }); }

function genFallback(id) {
  var g = Array.from({ length: 40 }, function() { return Array(40).fill(0); });
  var s = ((id * 16807 + 7) % 2147483647);
  var rand = function() { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
  for (var r = 4; r < 36; r++) for (var c = 6; c < 34; c++) {
    var dx = (c - 20) / 13, dy = (r - 20) / 15;
    if (dx * dx + dy * dy < 1 && dx * dx + dy * dy > 0.7) g[r][c] = 1;
  }
  var ey = 14 + Math.floor(rand() * 4), ew = 2 + Math.floor(rand() * 2);
  for (var dy2 = 0; dy2 < 2; dy2++) for (var dx2 = 0; dx2 < ew; dx2++) {
    if (ey + dy2 < 40) { g[ey + dy2][12 + dx2] = 1; g[ey + dy2][26 + dx2] = 1; }
  }
  var ny = 20 + Math.floor(rand() * 3);
  if (ny + 1 < 40) { g[ny][20] = 1; g[ny + 1][19] = 1; g[ny + 1][20] = 1; g[ny + 1][21] = 1; }
  return g;
}

function downsample(p40) {
  var b = emptyBoard();
  for (var r = 0; r < BH; r++) for (var c = 0; c < BW; c++) {
    var ct = 0;
    for (var dr = 0; dr < 2; dr++) for (var dc = 0; dc < 2; dc++) {
      if (p40[r * 2 + dr] && p40[r * 2 + dr][c * 2 + dc]) ct++;
    }
    b[r][c] = ct >= 1 ? 1 : 0;
  }
  return b;
}

function collides(cells, px, py, brd) {
  for (var i = 0; i < cells.length; i++) {
    var nx = px + cells[i][0], ny = py + cells[i][1];
    if (nx < 0 || nx >= BW || ny >= BH) return true;
    if (ny >= 0 && brd[ny] && brd[ny][nx] !== 0) return true;
  }
  return false;
}

function refillQueue(q) {
  var newQ = q.slice();
  while (newQ.length < 6) {
    var w = [8, 8, 8, 8, 8, 8, 8, 3, 5, 4, 4];
    var r = Math.random() * 71, idx = 0;
    for (var j = 0; j < w.length; j++) { r -= w[j]; if (r <= 0) { idx = j; break; } }
    newQ.push({ name: SHAPES[idx].name, cells: SHAPES[idx].cells.map(function(c) { return [c[0], c[1]]; }) });
  }
  return newQ;
}

function renderShapeMini(shape, sz) {
  sz = sz || 10;
  if (!shape) return null;
  var mx = 0, my = 0;
  for (var i = 0; i < shape.cells.length; i++) {
    if (shape.cells[i][0] > mx) mx = shape.cells[i][0];
    if (shape.cells[i][1] > my) my = shape.cells[i][1];
  }
  mx++; my++;
  return (
    <div style={{ width: mx * sz, height: my * sz, position: "relative", margin: "0 auto" }}>
      {shape.cells.map(function(cell, i) {
        return <div key={i} style={{ position: "absolute", left: cell[0] * sz, top: cell[1] * sz, width: sz - 1, height: sz - 1, background: DARK, borderRadius: 1 }} />;
      })}
    </div>
  );
}

function generateShareImage(normiePixels, board, bColors, target, tokenId, finalScore, accuracy) {
  var W = 800, H = 500;
  var canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  var ctx = canvas.getContext("2d");
  var bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, "#0c0c0e"); bg.addColorStop(1, "#141418");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = LIGHT; ctx.font = "bold 32px monospace"; ctx.textAlign = "center";
  ctx.fillText("NORMIE TETRIS", W / 2, 52);
  ctx.font = "13px monospace"; ctx.fillStyle = "#666";
  ctx.fillText("Normie #" + tokenId, W / 2, 72);
  var nS = 220, nPx = nS / 40, nX = 90, nY = 105;
  ctx.fillStyle = LIGHT; ctx.fillRect(nX, nY, nS, nS);
  if (normiePixels) {
    for (var r = 0; r < 40; r++) for (var c = 0; c < 40; c++) {
      if (normiePixels[r] && normiePixels[r][c]) { ctx.fillStyle = DARK; ctx.fillRect(nX + c * nPx, nY + r * nPx, nPx, nPx); }
    }
  }
  ctx.fillStyle = "#666"; ctx.font = "11px monospace";
  ctx.fillText("ORIGINAL", nX + nS / 2, nY + nS + 18);
  var bS = 220, bPx2 = bS / BW, bX = 490, bY = 105;
  ctx.fillStyle = LIGHT; ctx.fillRect(bX, bY, bS, bS);
  for (var r2 = 0; r2 < BH; r2++) for (var c2 = 0; c2 < BW; c2++) {
    if (board[r2][c2]) {
      ctx.fillStyle = (bColors[r2] && bColors[r2][c2]) || DARK;
      ctx.fillRect(bX + c2 * bPx2, bY + r2 * bPx2, bPx2 - 0.5, bPx2 - 0.5);
    }
  }
  ctx.fillStyle = LIGHT; ctx.font = "bold 20px monospace";
  ctx.fillText("Score: " + finalScore.toLocaleString() + "  |  Accuracy: " + accuracy + "%", W / 2, 422);
  ctx.fillStyle = "#444"; ctx.font = "12px monospace";
  ctx.fillText("normies.art  |  #NormieTetris", W / 2, H - 22);
  return canvas;
}

export default function Tetris() {
  var _s = useState("menu"), screen = _s[0], setScreen = _s[1];
  var _t = useState("0"), tokenId = _t[0], setTokenId = _t[1];
  var _np = useState(null), normiePixels = _np[0], setNormiePixels = _np[1];
  var _tg = useState(null), target = _tg[0], setTarget = _tg[1];
  var _b = useState(emptyBoard), board = _b[0], setBoard = _b[1];
  var _bc = useState(emptyColors), bColors = _bc[0], setBColors = _bc[1];
  var _cp = useState(null), curPiece = _cp[0], setCurPiece = _cp[1];
  var _po = useState({ x: 0, y: 0 }), pos = _po[0], setPos = _po[1];
  var _sq = useState([]), shapeQueue = _sq[0], setShapeQueue = _sq[1];
  var _sc = useState(0), score = _sc[0], setScore = _sc[1];
  var _fi = useState(0), filled = _fi[0], setFilled = _fi[1];
  var _tt = useState(0), totalTgt = _tt[0], setTotalTgt = _tt[1];
  var _pl = useState(0), placed = _pl[0], setPlaced = _pl[1];
  var _lo = useState(false), loading = _lo[0], setLoading = _lo[1];
  var _pa = useState(false), paused = _pa[0], setPaused = _pa[1];
  var _ms = useState(""), msg = _ms[0], setMsg = _ms[1];
  var _si = useState(null), shareImg = _si[0], setShareImg = _si[1];
  var _lv = useState(1), level = _lv[0], setLevel = _lv[1];

  var dead = useRef(false);
  var loopRef = useRef(null);
  var boardR = useRef(board); boardR.current = board;
  var colorsR = useRef(bColors); colorsR.current = bColors;
  var pieceR = useRef(curPiece); pieceR.current = curPiece;
  var posR = useRef(pos); posR.current = pos;
  var targetR = useRef(target); targetR.current = target;
  var pausedR = useRef(paused); pausedR.current = paused;
  var queueR = useRef(shapeQueue); queueR.current = shapeQueue;
  var pixelsR = useRef(normiePixels); pixelsR.current = normiePixels;
  var tokenR = useRef(tokenId); tokenR.current = tokenId;
  var scoreR = useRef(0);
  var placedR = useRef(0);

  var stopLoop = useCallback(function() {
    if (loopRef.current) { clearInterval(loopRef.current); loopRef.current = null; }
  }, []);

  var endGame = useCallback(function(message, fb, fc, fs) {
    if (dead.current) return;
    dead.current = true;
    stopLoop();
    setMsg(message); setScreen("gameover"); setCurPiece(null);
    setTimeout(function() {
      try {
        var tgt = targetR.current;
        var total = tgt ? tgt.flat().filter(function(v) { return v; }).length : 1;
        var f = 0;
        for (var r = 0; r < BH; r++) for (var c = 0; c < BW; c++) {
          if (fb[r] && fb[r][c] && tgt && tgt[r] && tgt[r][c] && fc[r] && fc[r][c] === CORRECT) f++;
        }
        var acc = Math.round((f / Math.max(total, 1)) * 100);
        var canvas = generateShareImage(pixelsR.current, fb, fc, tgt, tokenR.current, fs, acc);
        setShareImg(canvas.toDataURL("image/png"));
      } catch (e) { console.error(e); }
    }, 200);
  }, [stopLoop]);

  var lockAndSpawn = useCallback(function(piece, px, py) {
    if (dead.current || !piece) return;
    var tgt = targetR.current;
    if (!tgt) return;
    var nb = boardR.current.map(function(r) { return r.slice(); });
    var nc = colorsR.current.map(function(r) { return r.slice(); });
    var correct = 0, wrong = 0;
    for (var i = 0; i < piece.cells.length; i++) {
      var nx = px + piece.cells[i][0], ny = py + piece.cells[i][1];
      if (ny >= 0 && ny < BH && nx >= 0 && nx < BW) {
        nb[ny][nx] = 1;
        if (tgt[ny] && tgt[ny][nx] === 1) { nc[ny][nx] = CORRECT; correct++; }
        else { nc[ny][nx] = WRONG; wrong++; }
      }
    }
    var ns = scoreR.current + correct * 100 - wrong * 30;
    scoreR.current = ns; placedR.current++;
    setBoard(nb); setBColors(nc); setScore(ns); setPlaced(placedR.current);
    setLevel(Math.floor(placedR.current / 12) + 1);
    var f = 0, total = 0;
    for (var r = 0; r < BH; r++) for (var c = 0; c < BW; c++) {
      if (tgt[r] && tgt[r][c]) total++;
      if (nb[r][c] && tgt[r] && tgt[r][c] && nc[r][c] === CORRECT) f++;
    }
    setFilled(f); setTotalTgt(total);
    if (total > 0 && f >= total * 0.85) { endGame("NORMIE COMPLETE! \uD83C\uDFC6", nb, nc, ns); return; }
    var topHit = false;
    for (var c2 = 0; c2 < BW; c2++) { if (nb[0][c2]) { topHit = true; break; } }
    if (topHit) { endGame("TOP REACHED! \uD83D\uDC80", nb, nc, ns); return; }
    var q = refillQueue(queueR.current);
    var next = q[0], rest = q.slice(1), mx = 0;
    for (var k = 0; k < next.cells.length; k++) { if (next.cells[k][0] > mx) mx = next.cells[k][0]; }
    var spx = Math.floor((BW - mx - 1) / 2);
    if (collides(next.cells, spx, 0, nb)) { endGame("BLOCKED! \uD83D\uDC80", nb, nc, ns); return; }
    setCurPiece(next); setPos({ x: spx, y: 0 }); setShapeQueue(refillQueue(rest));
  }, [endGame]);

  var tick = useCallback(function() {
    if (pausedR.current || dead.current) return;
    var piece = pieceR.current, p = posR.current;
    if (!piece) return;
    if (collides(piece.cells, p.x, p.y + 1, boardR.current)) lockAndSpawn(piece, p.x, p.y);
    else setPos({ x: p.x, y: p.y + 1 });
  }, [lockAndSpawn]);

  var placePiece = useCallback(function() {
    if (pausedR.current || dead.current) return;
    var piece = pieceR.current, p = posR.current;
    if (!piece) return;
    lockAndSpawn(piece, p.x, p.y);
  }, [lockAndSpawn]);

  var moveH = useCallback(function(dx) {
    if (pausedR.current || dead.current) return;
    var piece = pieceR.current, p = posR.current;
    if (!piece) return;
    if (!collides(piece.cells, p.x + dx, p.y, boardR.current)) setPos({ x: p.x + dx, y: p.y });
  }, []);

  var moveDown = useCallback(function() {
    if (pausedR.current || dead.current) return;
    var piece = pieceR.current, p = posR.current;
    if (!piece) return;
    if (!collides(piece.cells, p.x, p.y + 1, boardR.current)) setPos({ x: p.x, y: p.y + 1 });
  }, []);

  var rotatePiece = useCallback(function() {
    if (pausedR.current || dead.current) return;
    var piece = pieceR.current, p = posR.current;
    if (!piece || piece.name === "O" || piece.name === "dot") return;
    var nc = normRotate(piece.cells);
    if (!collides(nc, p.x, p.y, boardR.current)) setCurPiece({ name: piece.name, cells: nc });
    else if (!collides(nc, p.x + 1, p.y, boardR.current)) { setCurPiece({ name: piece.name, cells: nc }); setPos({ x: p.x + 1, y: p.y }); }
    else if (!collides(nc, p.x - 1, p.y, boardR.current)) { setCurPiece({ name: piece.name, cells: nc }); setPos({ x: p.x - 1, y: p.y }); }
  }, []);

  var switchShape = useCallback(function(qIdx) {
    if (pausedR.current || dead.current) return;
    var q = queueR.current.slice(), swap = q[qIdx];
    if (!swap) return;
    var piece = pieceR.current, p = posR.current;
    if (!piece) return;
    var mx = 0;
    for (var k = 0; k < swap.cells.length; k++) { if (swap.cells[k][0] > mx) mx = swap.cells[k][0]; }
    var nx = Math.min(p.x, BW - mx - 1);
    if (nx < 0) nx = 0;
    if (collides(swap.cells, nx, p.y, boardR.current)) return;
    q[qIdx] = piece;
    setCurPiece(swap); setPos({ x: nx, y: p.y }); setShapeQueue(q);
  }, []);

  useEffect(function() {
    if (screen !== "playing") return;
    var h = function(e) {
      switch (e.key) {
        case "ArrowLeft": e.preventDefault(); moveH(-1); break;
        case "ArrowRight": e.preventDefault(); moveH(1); break;
        case "ArrowUp": e.preventDefault(); rotatePiece(); break;
        case "ArrowDown": e.preventDefault(); moveDown(); break;
        case " ": case "Enter": e.preventDefault(); placePiece(); break;
        case "p": case "P": setPaused(function(v) { return !v; }); break;
        case "1": switchShape(0); break;
        case "2": switchShape(1); break;
        case "3": switchShape(2); break;
        case "4": switchShape(3); break;
        default: break;
      }
    };
    window.addEventListener("keydown", h);
    return function() { window.removeEventListener("keydown", h); };
  }, [screen, moveH, moveDown, rotatePiece, placePiece, switchShape]);

  useEffect(function() {
    if (screen !== "playing") { stopLoop(); return; }
    var speed = Math.max(250, 900 - level * 50);
    loopRef.current = setInterval(tick, speed);
    return function() { stopLoop(); };
  }, [screen, level, tick, stopLoop]);

  var fetchNormie = function(id) {
    setLoading(true);
    return fetch("https://api.normies.art/normie/" + id + "/pixels")
      .then(function(r) { if (!r.ok) throw new Error(); return r.text(); })
      .then(function(t) {
        if (t.length !== 1600) throw new Error();
        var g = [];
        for (var r2 = 0; r2 < 40; r2++) {
          var row = [];
          for (var c = 0; c < 40; c++) row.push(parseInt(t[r2 * 40 + c], 10));
          g.push(row);
        }
        return g;
      })
      .catch(function() { return genFallback(parseInt(id, 10) || 0); })
      .finally(function() { setLoading(false); });
  };

  var startGame = function() {
    stopLoop(); dead.current = false;
    fetchNormie(parseInt(tokenId, 10) || 0).then(function(px) {
      var tgt = downsample(px);
      var total = 0;
      for (var r = 0; r < BH; r++) for (var c = 0; c < BW; c++) { if (tgt[r][c]) total++; }
      setNormiePixels(px); setTarget(tgt); setTotalTgt(total); setFilled(0);
      setBoard(emptyBoard()); setBColors(emptyColors());
      setScore(0); scoreR.current = 0; setPlaced(0); placedR.current = 0;
      setLevel(1); setPaused(false); setMsg(""); setShareImg(null);
      var q = refillQueue([]);
      var first = q[0], mx = 0;
      for (var k = 0; k < first.cells.length; k++) { if (first.cells[k][0] > mx) mx = first.cells[k][0]; }
      setCurPiece(first); setPos({ x: Math.floor((BW - mx - 1) / 2), y: 0 });
      setShapeQueue(refillQueue(q.slice(1))); setScreen("playing");
    });
  };

  var postToX = function() {
    var acc = totalTgt > 0 ? Math.round((filled / totalTgt) * 100) : 0;
    var text = encodeURIComponent("My Normie Tetris Score: " + score.toLocaleString() + " \uD83C\uDFAE\n\nNormie #" + tokenId + " \u00B7 Accuracy: " + acc + "%\n\nRebuild YOUR Normie \u2192 normies.art\n\n#Normies #NormieTetris #OnChain");
    window.open("https://x.com/intent/tweet?text=" + text, "_blank");
  };

  var downloadImg = function() {
    if (!shareImg) return;
    var a = document.createElement("a"); a.download = "normie-tetris-" + tokenId + ".png"; a.href = shareImg; a.click();
  };

  var accuracy = totalTgt > 0 ? Math.round((filled / totalTgt) * 100) : 0;
  var boardPxW = BW * CELL, boardPxH = BH * CELL;

  var normie40SVG = useCallback(function() {
    if (!normiePixels) return "";
    var rects = "";
    for (var r = 0; r < 40; r++) for (var c = 0; c < 40; c++) {
      if (normiePixels[r] && normiePixels[r][c]) rects += '<rect x="' + c + '" y="' + r + '" width="1" height="1" fill="' + DARK + '"/>';
    }
    return 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="' + LIGHT + '"/>' + rects + '</svg>');
  }, [normiePixels]);

  var cBtn = { padding: "10px 14px", borderRadius: 6, border: "1px solid rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.06)", color: LIGHT, fontSize: 16, cursor: "pointer", fontWeight: 700, fontFamily: "inherit", userSelect: "none", WebkitUserSelect: "none" };
  var glass = { background: "rgba(10,10,12,0.72)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", borderRadius: 8, border: "1px solid rgba(255,255,255,0.07)" };

  if (screen === "menu") {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 56px)", padding: "20px 16px" }}>
        <div style={{ maxWidth: 400, width: "100%", textAlign: "center" }}>
          <div style={{ perspective: 600, marginBottom: 28 }}>
            <div style={{ transform: "rotateX(12deg)", transformOrigin: "center bottom" }}>
              <div style={{ fontSize: 10, letterSpacing: "0.3em", color: "#555", marginBottom: 6, textTransform: "uppercase" }}>{"\u25BC"} Look Down {"\u25BC"}</div>
              <h2 style={{ fontSize: 32, fontWeight: 700, margin: 0, background: "linear-gradient(180deg," + LIGHT + ",#888)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>NORMIE TETRIS</h2>
              <p style={{ fontSize: 12, color: "#666", margin: "4px 0 0" }}>Rebuild your face in the pit</p>
            </div>
          </div>
          <div style={{ background: "rgba(255,255,255,0.03)", borderRadius: 10, border: "1px solid rgba(255,255,255,0.06)", padding: 20, marginBottom: 16, textAlign: "left" }}>
            <label style={{ fontSize: 10, letterSpacing: "0.1em", textTransform: "uppercase", color: "#666", display: "block", marginBottom: 6 }}>Token ID (0-9999)</label>
            <input type="number" min="0" max="9999" value={tokenId} onChange={function(e) { setTokenId(e.target.value); }}
              style={{ width: "100%", padding: "12px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.1)", background: "rgba(255,255,255,0.04)", color: LIGHT, fontFamily: "inherit", fontSize: 22, fontWeight: 700, outline: "none", textAlign: "center", boxSizing: "border-box" }} />
          </div>
          <button onClick={startGame} disabled={loading}
            style={{ width: "100%", padding: 14, borderRadius: 10, border: "none", background: "linear-gradient(135deg," + DARK + ",#333)", color: LIGHT, fontSize: 15, fontWeight: 700, cursor: loading ? "wait" : "pointer", fontFamily: "inherit", letterSpacing: "0.06em", textTransform: "uppercase" }}>
            {loading ? "LOADING..." : "DROP INTO THE PIT"}</button>
          <div style={{ marginTop: 20, padding: 14, borderRadius: 8, border: "1px solid rgba(255,255,255,0.06)", fontSize: 11, color: "#555", lineHeight: 1.7, textAlign: "left" }}>
            <strong style={{ color: "#999" }}>Controls</strong><br />
            {"\u2190 \u2192"} Move {"\u00B7"} {"\u2191"} Rotate {"\u00B7"} {"\u2193"} Nudge down<br />
            Space/Enter = PLACE block where it is<br />
            1-4 Swap shape {"\u00B7"} P Pause
          </div>
        </div>
      </div>);
  }

  if (screen === "gameover") {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 56px)", padding: "20px 16px" }}>
        <div style={{ maxWidth: 480, width: "100%", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 4 }}>{accuracy >= 85 ? "\uD83C\uDFC6" : "\uD83D\uDC80"}</div>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 2px" }}>{msg}</h2>
          <p style={{ fontSize: 12, color: "#666", margin: "0 0 20px" }}>Normie #{tokenId}</p>
          {shareImg && (<div style={{ marginBottom: 16, borderRadius: 8, overflow: "hidden", border: "1px solid rgba(255,255,255,0.08)" }}>
            <img src={shareImg} alt="Result" style={{ width: "100%", display: "block" }} /></div>)}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 16 }}>
            {[{ l: "Accuracy", v: accuracy + "%" }, { l: "Score", v: score.toLocaleString() }, { l: "Pieces", v: placed }].map(function(item) { return (
              <div key={item.l} style={{ background: "rgba(255,255,255,0.03)", borderRadius: 8, padding: "10px 6px", border: "1px solid rgba(255,255,255,0.06)" }}>
                <div style={{ fontSize: 18, fontWeight: 700 }}>{item.v}</div>
                <div style={{ fontSize: 9, color: "#555", textTransform: "uppercase", marginTop: 3 }}>{item.l}</div></div>); })}
          </div>
          <button onClick={postToX}
            style={{ width: "100%", padding: 14, borderRadius: 10, border: "none", background: "#000", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 8 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
            Post My Score to X</button>
          {shareImg && (<button onClick={downloadImg} style={{ width: "100%", padding: 12, borderRadius: 10, border: "1px solid rgba(255,255,255,0.12)", background: "transparent", color: LIGHT, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", textTransform: "uppercase", marginBottom: 8 }}>{"\u2B07"} Download Image</button>)}
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={startGame} style={{ flex: 1, padding: 12, borderRadius: 8, border: "none", background: LIGHT, color: DARK, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", textTransform: "uppercase" }}>Retry</button>
            <button onClick={function() { setScreen("menu"); }} style={{ flex: 1, padding: 12, borderRadius: 8, border: "1px solid rgba(255,255,255,0.15)", background: "transparent", color: LIGHT, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", textTransform: "uppercase" }}>New</button>
          </div>
        </div>
      </div>);
  }

  var topDanger = 0;
  for (var dr = 0; dr < 3; dr++) for (var dc = 0; dc < BW; dc++) { if (board[dr] && board[dr][dc]) topDanger++; }
  topDanger = topDanger / (BW * 3);

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "calc(100vh - 56px)", alignItems: "center", justifyContent: "center" }}>
      {topDanger > 0.2 && <div style={{ position: "fixed", top: 56, left: 0, right: 0, height: 3, background: "rgba(168,56,40," + Math.min(topDanger * 1.2, 0.9) + ")", zIndex: 50 }} />}
      <div style={{ position: "relative" }}>
        <div style={{ perspective: 800, perspectiveOrigin: "50% 30%" }}>
          <div style={{ transformStyle: "preserve-3d", transform: "rotateX(18deg)", transformOrigin: "50% 50%", position: "relative", padding: "0 30px" }}>
            <div style={{ position: "absolute", left: 0, top: 0, width: 30, height: boardPxH, background: "linear-gradient(90deg,#0e0e11,#141417)", transform: "rotateY(60deg)", transformOrigin: "left center" }} />
            <div style={{ position: "absolute", right: 0, top: 0, width: 30, height: boardPxH, background: "linear-gradient(270deg,#0e0e11,#141417)", transform: "rotateY(-60deg)", transformOrigin: "right center" }} />
            <div style={{ position: "absolute", left: 30, top: 0, width: boardPxW, height: CELL, background: "linear-gradient(180deg,rgba(168,56,40," + (0.06 + topDanger * 0.3) + "),transparent)", borderTop: "2px solid rgba(168,56,40," + (0.1 + topDanger * 0.5) + ")", zIndex: 2, pointerEvents: "none" }} />
            <div style={{ width: boardPxW, height: boardPxH, background: "#111114", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 2, boxShadow: "inset 0 0 60px rgba(0,0,0,0.7)", overflow: "hidden", position: "relative", marginLeft: 30 }}>
              {normiePixels && (<div style={{ position: "absolute", inset: 0, backgroundImage: 'url("' + normie40SVG() + '")', backgroundSize: "cover", opacity: 0.06, pointerEvents: "none" }} />)}
              {Array.from({ length: BW - 1 }, function(_, i) { return <div key={"v" + i} style={{ position: "absolute", left: (i + 1) * CELL, top: 0, width: 1, height: "100%", background: "rgba(255,255,255,0.015)" }} />; })}
              {Array.from({ length: BH - 1 }, function(_, i) { return <div key={"h" + i} style={{ position: "absolute", top: (i + 1) * CELL, left: 0, height: 1, width: "100%", background: "rgba(255,255,255,0.015)" }} />; })}
              {target && target.map(function(row, r) { return row.map(function(v, c) { return v ? (<div key={"t" + r + "-" + c} style={{ position: "absolute", left: c * CELL, top: r * CELL, width: CELL, height: CELL, background: "rgba(72,73,75,0.2)" }} />) : null; }); })}
              {board.map(function(row, r) { return row.map(function(v, c) { return v ? (<div key={"b" + r + "-" + c} style={{ position: "absolute", left: c * CELL, top: r * CELL, width: CELL - 1, height: CELL - 1, background: (bColors[r] && bColors[r][c]) || DARK, borderRadius: 1, boxShadow: (bColors[r] && bColors[r][c]) === WRONG ? "0 0 6px rgba(168,56,40,0.4)" : "0 1px 3px rgba(0,0,0,0.5)" }} />) : null; }); })}
              {curPiece && !paused && curPiece.cells.map(function(cell, i) {
                var px2 = pos.x + cell[0], py2 = pos.y + cell[1];
                var onT = target && target[py2] && target[py2][px2];
                return py2 >= 0 ? (<div key={"p" + i} style={{ position: "absolute", left: px2 * CELL, top: py2 * CELL, width: CELL - 1, height: CELL - 1, background: LIGHT, borderRadius: 1, boxShadow: "0 0 12px rgba(227,229,228,0.4),0 2px 4px rgba(0,0,0,0.5)", outline: onT ? "2px solid rgba(100,220,100,0.5)" : "none", transition: "left 0.05s,top 0.05s" }} />) : null;
              })}
              {paused && (<div style={{ position: "absolute", inset: 0, background: "rgba(10,10,12,0.85)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, fontWeight: 700, color: "#555" }}>PAUSED</div>)}
            </div>
          </div>
        </div>
        <div style={{ position: "absolute", top: -6, left: 0, padding: "8px 12px", zIndex: 10, ...glass }}>
          <div style={{ fontSize: 9, color: "#666", textTransform: "uppercase", letterSpacing: "0.1em" }}>#{tokenId} {"\u00B7"} LVL {level}</div>
          <div style={{ fontSize: 22, fontWeight: 700, marginTop: 2 }}>{score.toLocaleString()}</div>
          <div style={{ fontSize: 10, color: accuracy >= 60 ? "#6a6" : "#888", marginTop: 2 }}>{accuracy}% {"\u00B7"} {filled}/{totalTgt}</div>
          <div style={{ marginTop: 4, height: 4, borderRadius: 2, background: "rgba(255,255,255,0.08)", overflow: "hidden", width: 90 }}>
            <div style={{ height: "100%", borderRadius: 2, width: Math.min(100, (accuracy / 85) * 100) + "%", background: accuracy >= 85 ? "#5a5" : LIGHT, transition: "width 0.3s" }} />
          </div>
        </div>
        <div style={{ position: "absolute", top: -6, right: 0, display: "flex", gap: 6, zIndex: 10 }}>
          <div style={{ padding: 6, textAlign: "center", ...glass }}>
            <div style={{ fontSize: 7, color: "#555", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 3 }}>Target</div>
            <div style={{ width: 64, height: 64, borderRadius: 3, overflow: "hidden", border: "1px solid rgba(255,255,255,0.08)", background: LIGHT, position: "relative" }}>
              {normiePixels && normiePixels.map(function(row, r) { return row.map(function(v, c) { return v ? (<div key={"n" + r + "-" + c} style={{ position: "absolute", left: c * 1.6, top: r * 1.6, width: 1.6, height: 1.6, background: DARK }} />) : null; }); })}
            </div>
          </div>
          <div style={{ padding: 6, textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center", ...glass, border: "1px solid rgba(227,229,228,0.12)" }}>
            <div style={{ fontSize: 7, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>Current</div>
            <div style={{ minHeight: 28, display: "flex", justifyContent: "center", alignItems: "center" }}>{curPiece && renderShapeMini(curPiece, 10)}</div>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: -72, left: "50%", transform: "translateX(-50%)", display: "flex", gap: 8, alignItems: "center", zIndex: 10, flexWrap: "nowrap" }}>
          <div style={{ display: "flex", gap: 4, padding: "6px 8px", ...glass }}>
            {shapeQueue.slice(0, 4).map(function(shape, i) { return (
              <button key={i} onClick={function() { switchShape(i); }} onTouchStart={function(e) { e.preventDefault(); switchShape(i); }}
                style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 5px", borderRadius: 5, cursor: "pointer", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.03)", minWidth: 34, minHeight: 34, position: "relative" }}>
                <span style={{ position: "absolute", left: 2, top: 1, fontSize: 7, color: "#444" }}>{i + 1}</span>
                {renderShapeMini(shape, 7)}
              </button>); })}
          </div>
          <div style={{ display: "flex", gap: 4, padding: "6px 8px", ...glass }}>
            <button onClick={function() { moveH(-1); }} onTouchStart={function(e) { e.preventDefault(); moveH(-1); }} style={cBtn}>{"\u2190"}</button>
            <button onClick={moveDown} onTouchStart={function(e) { e.preventDefault(); moveDown(); }} style={cBtn}>{"\u2193"}</button>
            <button onClick={rotatePiece} onTouchStart={function(e) { e.preventDefault(); rotatePiece(); }} style={cBtn}>{"\u21BB"}</button>
            <button onClick={function() { moveH(1); }} onTouchStart={function(e) { e.preventDefault(); moveH(1); }} style={cBtn}>{"\u2192"}</button>
          </div>
          <button onClick={placePiece} onTouchStart={function(e) { e.preventDefault(); placePiece(); }}
            style={{ padding: "12px 24px", borderRadius: 8, border: "none", background: "linear-gradient(135deg," + LIGHT + ",#ccc)", color: "#0a0a0c", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", letterSpacing: "0.06em", textTransform: "uppercase", boxShadow: "0 3px 16px rgba(227,229,228,0.25)" }}>
            PLACE
          </button>
          <button onClick={function() { setPaused(function(v) { return !v; }); }}
            style={{ padding: "10px 14px", borderRadius: 8, color: LIGHT, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", border: "none", ...glass }}>
            {paused ? "\u25B6" : "\u23F8"}
          </button>
        </div>
      </div>
    </div>
  );
}
